export default class QzsSelector {
  public static selectConnectionMessages(state: ReduxState) {
    return state.qz.connectionMessages;
  }
}
